
import React from 'react';
import { Badge } from '@/components/ui/badge';
import { UserRole } from '@/context/auth/types';

interface RoleBadgeProps {
  role?: UserRole | string;
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const RoleBadge: React.FC<RoleBadgeProps> = ({ 
  role, 
  size = 'md',
  className 
}) => {
  // Get color class based on role
  const getRoleColorClass = (role?: string) => {
    switch(role) {
      case UserRole.SUPER_ADMIN:
        return 'bg-ubereats-green text-brand-white border-transparent';
      case UserRole.ORG_ADMIN:
        return 'bg-brand-red text-brand-white border-transparent';
      case UserRole.REST_ADMIN:
        return 'bg-brand-blue text-brand-white border-transparent';
      default:
        return 'bg-brand-grey text-brand-dark-text border-transparent';
    }
  };
  
  // Format role for display
  const formatRole = (role?: string) => {
    if (!role) return 'User';
    
    // Convert snake_case to Title Case
    return role
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
  };
  
  // Size styles
  const sizeStyles = {
    sm: 'text-[10px] px-1 py-0',
    md: 'text-xs px-2 py-0.5',
    lg: 'text-sm px-2.5 py-1'
  };
  
  return (
    <span 
      className={`inline-flex items-center rounded-full border font-semibold transition-colors ${getRoleColorClass(role)} ${sizeStyles[size]} ${className || ''}`}
    >
      {formatRole(role)}
    </span>
  );
};

export default RoleBadge;
